// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&family=Roboto:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #713f12;
  --secondary-color: #b58863;
  --third-color: #f0d9b5;
}
:root.second-theme {
  --primary-color: #1e3a8a;
  --secondary-color: #3b82f6;
  --third-color: #dbeafe;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Montserrat", sans-serif;
}

body {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 100vh;
}

header {
  width: 600px;
  padding: 20px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
header h1 {
  color: var(--primary-color);
  font-size: 2.4em;
}
header .right-side {
  display: flex;
  align-items: center;
  gap: 20px;
}
header .right-side button {
  padding: 5px 20px;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 1.2em;
  font-weight: bold;
  cursor: pointer;
  transition: filter 0.2s;
}
header .right-side button:hover {
  filter: brightness(105%);
}
header .theme {
  background-color: var(--third-color);
  color: var(--secondary-color) !important;
}
header .reset {
  background-color: #f87171;
}

#chessboard {
  width: 600px;
  height: 600px;
  display: grid;
  display: flex;
  flex-wrap: wrap;
  border: 8px solid var(--primary-color);
  border-radius: 10px;
}
#chessboard .square {
  width: 12.5%;
  height: 12.5%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#chessboard .black {
  background-color: var(--third-color);
}
#chessboard .white {
  background-color: var(--secondary-color);
}
#chessboard img {
  width: 40px;
}

.light-dark-mode {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}
.light-dark-mode img {
  width: 25px;
}

#instructions {
  width: 600px;
  padding: 5px;
  font-weight: bold;
  text-align: center;
  color: var(--primary-color);
  background-color: var(--third-color);
  margin-top: 20px;
  border-radius: 10px;
  border: 8px solid var(--primary-color);
}
#instructions h2 {
  font-size: 1.8em;
  margin-bottom: 10px;
}
#instructions p {
  font-size: 1.2em;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.2);
  color: var(--primary-color);
}

footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 10px;
  font-weight: bold;
}
footer p {
  color: var(--primary-color);
  text-align: center;
}
footer a {
  text-decoration: none;
  color: var(--secondary-color);
  transition: color 0.2s;
}
footer a:hover {
  color: var(--third-color);
}

@media (max-width: 650px) {
  header {
    width: 500px;
  }
  header h1 {
    font-size: 2em;
  }
  header button {
    font-size: 1em !important;
  }
  #chessboard {
    height: 500px;
    width: 500px;
  }
  #chessboard img {
    width: 30px;
  }
  #instructions {
    width: 500px;
  }
  #instructions h2 {
    font-size: 1.6em;
  }
  #instructions p {
    font-size: 1em;
  }
}
@media (max-width: 500px) {
  header {
    width: 350px;
  }
  header h1 {
    font-size: 1.3em;
  }
  header button {
    font-size: 0.8em !important;
    padding: 5px 10px !important;
  }
  #chessboard {
    height: 350px;
    width: 350px;
  }
  #chessboard img {
    width: 20px;
  }
  #instructions {
    width: 350px;
  }
  #instructions h2 {
    font-size: 1.2em;
  }
  #instructions p {
    font-size: 0.8em;
  }
}`, "",{"version":3,"sources":["webpack://./src/main.scss"],"names":[],"mappings":"AAEA;EACE,wBAAA;EACA,0BAAA;EACA,sBAAA;AAAF;AAEE;EACE,wBAAA;EACA,0BAAA;EACA,sBAAA;AAAJ;;AAIA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;EACA,qCAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AADF;;AAIA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;AAGE;EACE,2BAAA;EACA,gBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAFJ;AAII;EACE,iBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;AAFN;AAIM;EACE,wBAAA;AAFR;AAOE;EACE,oCAAA;EACA,wCAAA;AALJ;AAQE;EACE,yBAAA;AANJ;;AAUA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,sCAAA;EACA,mBAAA;AAPF;AASE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPJ;AAUE;EACE,oCAAA;AARJ;AAUE;EACE,wCAAA;AARJ;AAWE;EACE,WAAA;AATJ;;AAaA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAVF;AAWE;EACE,WAAA;AATJ;;AAaA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;EACA,oCAAA;EACA,gBAAA;EACA,mBAAA;EACA,sCAAA;AAVF;AAYE;EACE,gBAAA;EACA,mBAAA;AAVJ;AAYE;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,2BAAA;AAVJ;;AAcA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EAEA,iBAAA;AAZF;AAaE;EACE,2BAAA;EACA,kBAAA;AAXJ;AAaE;EACE,qBAAA;EACA,6BAAA;EACA,sBAAA;AAXJ;AAaI;EACE,yBAAA;AAXN;;AAgBA;EACE;IACE,YAAA;EAbF;EAeE;IACE,cAAA;EAbJ;EAeE;IACE,yBAAA;EAbJ;EAgBA;IACE,aAAA;IACA,YAAA;EAdF;EAgBE;IACE,WAAA;EAdJ;EAkBA;IACE,YAAA;EAhBF;EAkBE;IACE,gBAAA;EAhBJ;EAkBE;IACE,cAAA;EAhBJ;AACF;AAoBA;EACE;IACE,YAAA;EAlBF;EAoBE;IACE,gBAAA;EAlBJ;EAoBE;IACE,2BAAA;IACA,4BAAA;EAlBJ;EAqBA;IACE,aAAA;IACA,YAAA;EAnBF;EAqBE;IACE,WAAA;EAnBJ;EAuBA;IACE,YAAA;EArBF;EAuBE;IACE,gBAAA;EArBJ;EAuBE;IACE,gBAAA;EArBJ;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&family=Roboto:wght@400;700&display=swap');\r\n\r\n:root {\r\n  --primary-color: #713f12;\r\n  --secondary-color: #b58863;\r\n  --third-color: #f0d9b5;\r\n\r\n  &.second-theme {\r\n    --primary-color: #1e3a8a;\r\n    --secondary-color: #3b82f6;\r\n    --third-color: #dbeafe;\r\n  }\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Montserrat', sans-serif;\r\n}\r\n\r\nbody {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  position: relative;\r\n  height: 100vh;\r\n}\r\n\r\nheader {\r\n  width: 600px;\r\n  padding: 20px 0px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n\r\n  h1 {\r\n    color: var(--primary-color);\r\n    font-size: 2.4em;\r\n  }\r\n\r\n  .right-side {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n\r\n    button {\r\n      padding: 5px 20px;\r\n      color: white;\r\n      border: none;\r\n      border-radius: 10px;\r\n      font-size: 1.2em;\r\n      font-weight: bold;\r\n      cursor: pointer;\r\n      transition: filter 0.2s;\r\n\r\n      &:hover {\r\n        filter: brightness(105%);\r\n      }\r\n    }\r\n  }\r\n\r\n  .theme {\r\n    background-color: var(--third-color);\r\n    color: var(--secondary-color) !important;\r\n  }\r\n\r\n  .reset {\r\n    background-color: #f87171;\r\n  }\r\n}\r\n\r\n#chessboard {\r\n  width: 600px;\r\n  height: 600px;\r\n  display: grid;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  border: 8px solid var(--primary-color);\r\n  border-radius: 10px;\r\n\r\n  .square {\r\n    width: 12.5%;\r\n    height: 12.5%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .black {\r\n    background-color: var(--third-color);\r\n  }\r\n  .white {\r\n    background-color: var(--secondary-color);\r\n  }\r\n\r\n  img {\r\n    width: 40px;\r\n  }\r\n}\r\n\r\n.light-dark-mode {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 15px;\r\n  img {\r\n    width: 25px;\r\n  }\r\n}\r\n\r\n#instructions {\r\n  width: 600px;\r\n  padding: 5px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  color: var(--primary-color);\r\n  background-color: var(--third-color);\r\n  margin-top: 20px;\r\n  border-radius: 10px;\r\n  border: 8px solid var(--primary-color);\r\n\r\n  h2 {\r\n    font-size: 1.8em;\r\n    margin-bottom: 10px;\r\n  }\r\n  p {\r\n    font-size: 1.2em;\r\n    font-weight: bold;\r\n    padding: 5px 10px;\r\n    border-radius: 5px;\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n    color: var(--primary-color);\r\n  }\r\n}\r\n\r\nfooter {\r\n  position: absolute;\r\n  bottom: 0;\r\n  width: 100%;\r\n  padding: 10px;\r\n\r\n  font-weight: bold;\r\n  p {\r\n    color: var(--primary-color);\r\n    text-align: center;\r\n  }\r\n  a {\r\n    text-decoration: none;\r\n    color: var(--secondary-color);\r\n    transition: color 0.2s;\r\n\r\n    &:hover {\r\n      color: var(--third-color);\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 650px) {\r\n  header {\r\n    width: 500px;\r\n\r\n    h1 {\r\n      font-size: 2em;\r\n    }\r\n    button {\r\n      font-size: 1em !important;\r\n    }\r\n  }\r\n  #chessboard {\r\n    height: 500px;\r\n    width: 500px;\r\n\r\n    img {\r\n      width: 30px;\r\n    }\r\n  }\r\n\r\n  #instructions {\r\n    width: 500px;\r\n\r\n    h2 {\r\n      font-size: 1.6em;\r\n    }\r\n    p {\r\n      font-size: 1em;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n  header {\r\n    width: 350px;\r\n\r\n    h1 {\r\n      font-size: 1.3em;\r\n    }\r\n    button {\r\n      font-size: 0.8em !important;\r\n      padding: 5px 10px !important;\r\n    }\r\n  }\r\n  #chessboard {\r\n    height: 350px;\r\n    width: 350px;\r\n\r\n    img {\r\n      width: 20px;\r\n    }\r\n  }\r\n\r\n  #instructions {\r\n    width: 350px;\r\n\r\n    h2 {\r\n      font-size: 1.2em;\r\n    }\r\n    p {\r\n      font-size: 0.8em;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
